












































































































































































































import {
    Component,
    Prop,
    Vue,
    PropSync,
    Emit,
    Watch,
} from "vue-property-decorator";
import { WidgetConfiguration } from "../interfaces/widgetConfiguration";
import { WidgetState } from "../interfaces/widgetState";
import { WidgetPayload } from "../interfaces/widgetPayload";
import { Layout } from "../interfaces/layout";
import JitsiWidget from "@/components/widgets/jitsi/JitsiWidget.vue";
import ChatWidget from "@/components/widgets/chat/ChatWidget.vue";
import RadioButtonWidget from "@/components/widgets/radioButton/RadioButtonWidget.vue";
import DrawWidget from "@/components/widgets/draw/DrawWidget.vue";
import FileagentWidget from "@/components/widgets/fileagent/fileAgentWidget.vue";
import PlyrWidget from "@/components/widgets/plyr/PlyrWidget.vue";
import CloudflareplayerWidget from "@/components/widgets/cloudflareplayer/CloudflareplayerWidget.vue";
import MarkdownWidget from "@/components/widgets/markdown/MarkdownWidget.vue";
import { StudioAttributes } from "../interfaces/studioAttributes";

@Component({
    components: {
        JitsiWidget,
        ChatWidget,
        RadioButtonWidget,
        DrawWidget,
        FileagentWidget,
        PlyrWidget,
        MarkdownWidget,
        CloudflareplayerWidget,
    },
})
export default class WidgetGrid extends Vue {
    @Prop() showId?: boolean;
    @Prop() canControl?: boolean;
    @Prop() configurations!: WidgetConfiguration<WidgetState, WidgetPayload>[];
    @Prop() fullscreenWidgetId!: string | null;
    @Prop() resizable?: boolean;
    @Prop() draggable?: boolean;
    @Prop() showTitle?: boolean;

    @PropSync("layout") layoutProp!: Layout[];

    public deleteDialog: boolean = false;
    public deleteWidgetId: string | null = null;
    public editedTitle: string = "";

    @Emit() remove(widgetId: string | null) {
        this.deleteDialog = false;
        this.deleteWidgetId = null;
        return widgetId;
    }

    public layoutTooltip(widgetId: string): string {
        const layout: Layout | undefined = this.layoutProp.find(
            i => i.i == widgetId
        );
        return this.$t("script.widgetSize", {
            h: layout?.h,
            w: layout?.w,
        }) as string;
    }

    public updateTitle(event: {
        config: WidgetConfiguration<WidgetState, WidgetPayload>;
        payload: WidgetPayload;
    }) {
        this.editedTitle = "";
        this.update(event);
    }

    public editBtnHandler(widgetId: string) {
        if (this.editedTitle == widgetId) {
            this.editedTitle = "";
        } else this.editedTitle = widgetId;
    }

    @Emit() update(event: {
        config: WidgetConfiguration<WidgetState, WidgetPayload>;
        payload: WidgetPayload;
    }) {
        return event;
    }

    @Emit() resize(widgetId: string) {
        const [widget] =
            (this.$refs[widgetId] as (Vue & {
                resize: () => void;
            })[]) ?? [];

        widget?.resize();
    }

    public mounted() {
        this.$nextTick(() => this.onFullscreenChange(this.fullscreenWidgetId));
    }

    public onLayoutChange(ev: {
        i: string;
        newH: number;
        newW: number;
        newHPx: number;
        newWPx: number;
    }) {
        this.resize(ev.i);
        this.$emit("update:layout", this.layoutProp);
    }

    @Emit() public fullscreen(event: {
        widgetId: string;
        fullscreen: boolean;
    }) {
        this.resize(event.widgetId);
        return event;
    }
    @Emit() public studioAttributesChanged(event: Partial<StudioAttributes>) {
        return event;
    }
    public removeStart(widgetId: string) {
        this.deleteWidgetId = widgetId;
        this.deleteDialog = true;
    }

    public removeCancel() {
        this.deleteDialog = false;
        this.deleteWidgetId = null;
    }

    @Watch("fullscreenWidgetId")
    public onFullscreenChange(id: string | null) {
        if (!this.$refs.widgets) {
            return;
        }
        const widgets = this.$refs.widgets as (Vue & {
            isFullScreen: boolean;
            handlefullScreen(): void;
        })[];
        if (id) {
            widgets
                .filter(w => w.$vnode.key === id)
                .forEach(w => {
                    w.isFullScreen = false;
                    w.handlefullScreen();
                    this.resize(w.$vnode.key as string);
                });
        } else {
            widgets
                .filter(w => w.isFullScreen)
                .forEach(w => {
                    w.isFullScreen = true;
                    w.handlefullScreen();
                    this.resize(w.$vnode.key as string);
                });
        }
    }

    @Watch("layout")
    public onLayoutPropChange(layout: Layout[]) {
        layout.forEach(l => {
            this.resize(l.i);
        });
    }
}
